import { render, staticRenderFns } from "./categoriesCompare.vue?vue&type=template&id=978a9a26&scoped=true"
import script from "./categoriesCompare.vue?vue&type=script&lang=js"
export * from "./categoriesCompare.vue?vue&type=script&lang=js"
import style0 from "./categoriesCompare.vue?vue&type=style&index=0&id=978a9a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978a9a26",
  null
  
)

export default component.exports